export default __webpack_public_path__ + "media/kwjsMockup.3c46f991.mp4";